import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { SafeUrlPipe } from 'src/app/shared///pipe/safe_url/safe_url_pipe.pipe';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
declare var bootstrap: any;

@Component({
  selector: 'app-samples-list',
  standalone: true,
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    SafeUrlPipe,
    RouterLink
  ],
  templateUrl: './samples-list.component.html',
  styleUrl: './samples-list.component.scss'
})
export class SamplesListComponent {


  companyId: string | null = null;
  companyDetail: any;

  allCategoriesMini: any[] = [];

  sampleSearch = {
    name: '',
    category: undefined,
    startdate: null,
    enddate: null,
    barCode: ''
  };

  samplesDataSource = new MatTableDataSource<any>([]);

  sampleDisplayedColumns: string[] = [
  'name', 'sampleCode', 'totalItems', 'leftItems',
    'issuedWHL', 'issuedRTL', 'issuedCus', 'issuedTotal',
    'limitWHL', 'limitRTL', 'limitCus',
    'holdWHL', 'holdRTL',
    'createdAt', 'action'
  ];


  headerRowDef1: string[] = [
 'name', 'sampleCode', 'totalItems', 'leftItems',
    'issuedGroup', 'limitGroup', 'holdGroup', 'createdAt', 'action'
  ];
  headerRowDef2: string[] = [
    'issuedWHL', 'issuedRTL', 'issuedCus', 'issuedTotal',
    'limitWHL', 'limitRTL', 'limitCus',
    'holdWHL', 'holdRTL'
  ];

  sampleDetailModalInCompany: any;
  sampleData: any;

  startpoint = 0;
  totalLoaded = 0;
  total = 0;
  pageNo = 0;
    pageSize: number = 10;

  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private companyService: CompanyService,
    private categoryService: CategoryService,
    private sampleService: SampleService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.companyId = this.activatedRoute.snapshot.paramMap.get("companyId");
    this.getSingleCompany();
    this.getCategories();
    this.getAllSamples(null);
  }


  sampleFilter($event: any): void {
    this.getAllSamples(null);
  }
  onNameInputChange(event: any): void {
    const value = event.target.value
    clearTimeout(this.debounceNameTimer);

    this.debounceNameTimer = setTimeout(() => {
      this.sampleSearch.name = value;
      if (!value) delete this.sampleSearch.name;
      this.getAllSamples(null);
    }, 300);
  }

  onBarCodeInputChange(event: any): void {
    const value = event.target.value.trim();
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      this.sampleSearch.barCode = value;
      if (!value) delete this.sampleSearch.barCode;
      this.getAllSamples(null);
    }, 300);
  }

  clearDateRange(): void {
    this.sampleSearch.startdate = null;
    this.sampleSearch.enddate = null;
    this.getAllSamples(null);
  }

  openSDetailModal(sampleId: any): void {
    if (sampleId) {
      this.getSingleSample(sampleId);
      this.sampleDetailModalInCompany?.show();
    }
  }

  hideSDetailModal(): void {
    this.sampleDetailModalInCompany?.hide();
  }

  getImg(imgPath: string): string {
    return BASE_IMAGE_URL + imgPath;
  }


  ngAfterViewInit(): void {
    this.samplesDataSource.paginator = this.paginator;
    const modalElement = document.getElementById('sampleDetailModal');
    if (modalElement) {
      this.sampleDetailModalInCompany = new bootstrap.Modal(modalElement);
    }
  }


  getCategories(): void {
    this.categoryService.allCategoriesMini({}).subscribe({
      next: (res) => this.allCategoriesMini = res.data,
      error: () => this.toastr.error('Failed to load categories', 'Error')
    });
  }

  getSingleCompany(): void {
    if (!this.companyId) return;
    this.spinner.show();
    this.companyService.singleCompany({ _id: this.companyId }).subscribe({
      next: (res) => {
        if (res.success) {
          this.companyDetail = res.data;
        } else {
          console.warn(res.message);
        }
      },
      error: (e) => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }



  getSingleSample(sampleId: any): void {
    if (!sampleId) return;
    this.spinner.show();
    this.sampleService.singleSample({ _id: sampleId }).subscribe({
      next: (res) => {
        if (res.success) {
          this.sampleData = res.data;
        } else {
          console.warn(res.message);
        }
      },
      error: (e) => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }

  getSerialNumber(index: number): number {
    if (index === undefined) {
      console.warn('getSerialNumber: index is undefined');
      return 0;
    }

    const pageIndex = this.paginator?.pageIndex ?? 0;
    const pageSize = this.paginator?.pageSize ?? 10;

    return index + 1 + pageIndex * pageSize;
  }

getAllSamples(event: any): void {
  this.spinner.show();

  // Reset if no event (first load, search, or clear)
  if (!event) {
    this.pageNo = 0;
    this.startpoint = 0;
    this.pageSize = this.pageSize || PAGELENGTH;
    this.samplesDataSource.data = [];
    this.totalLoaded = 0;
  }

  // Handle page size change
  if (event?.pageSize && event.pageSize !== this.pageSize) {
    this.pageSize = event.pageSize;
    this.pageNo = 0;
    this.startpoint = 0;
    this.samplesDataSource.data = [];
    this.totalLoaded = 0;
  }

  // Handle page index change
  if (event?.pageIndex !== undefined) {
    this.pageNo = event.pageIndex;
    this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
  }

  const requestData: any = {
    startpoint: this.startpoint,
    limit: this.pageSize || PAGELENGTH,
    companyId: this.companyId
  };

  // Add filters if any
  if (this.sampleSearch.name) requestData.name = this.sampleSearch.name;
  if (this.sampleSearch.barCode) requestData.sampleCode = this.sampleSearch.barCode;
  if (this.sampleSearch.category) requestData.categoryId = this.sampleSearch.category;
  if (this.sampleSearch.startdate) requestData.startdate = this.sampleSearch.startdate;
  if (this.sampleSearch.enddate) requestData.enddate = this.sampleSearch.enddate;

  this.sampleService.allSamples(requestData).subscribe({
    next: (res) => {
      this.spinner.hide();
      if (res.success) {
        this.total = res.total ?? 0;
        this.samplesDataSource.data = res.data || [];
        this.totalLoaded = this.samplesDataSource.data.length;

        setTimeout(() => {
          if (this.paginator) {
            this.paginator.pageIndex = this.pageNo;
            this.paginator.length = this.total;
            this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
          }
        }, 0);
      }
    },
    error: (e) => {
      this.spinner.hide();
      this.toastr.error(e.message || 'Failed to load samples');
    }
  });
}




  print(heloo:any){
    console.log(heloo);
  }

}
